import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Row, Layout, Input, message, Form, Card, Col } from "antd";
import { PhoneOutlined } from "@ant-design/icons";
import { getIPAddressService, postLoginNoVerifyService, postLoginService, postVerifyService } from "./LoginPageService";
import Cookies from "universal-cookie";
import "./LoginPage.css";
import Copyright from "../../components/Copyright/Copyright";

const { Content } = Layout;

export interface LoginPageInterface {
  getUserRoleCookie: () => void;
}

const LoginPage = (props: LoginPageInterface) => {
  const [loading, setLoading] = useState(false);
  const [emailAddress, setEmailAddress] = useState("");
  const [emailAddressFormStatus, setEmailAddressFormStatus] = useState("") as any;
  const [emailAddressFormMessage, setEmailAddressFormMessage] = useState("");
  const [password, setPassword] = useState("");
  const [passwordFormStatus, setPasswordFormStatus] = useState("") as any;
  const [passwordFormMessage, setPasswordFormMessage] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [verificationCodeFormStatus, setVerificationCodeFormStatus] = useState("") as any;
  const [verificationCodeFormMessage, setVerificationCodeFormMessage] = useState("");
  const [loginErrorMessage, setLoginErrorMessage] = useState("");
  const [verifyErrorMessage, setVerifyErrorMessage] = useState("");
  const [showVerify, setShowVerify] = useState(false);
  const navigate = useNavigate();
  const cookies = new Cookies();

  useEffect(() => {}, []);

  const postLogin = async () => {
    // const resIP = await getIPAddressService();
    const payload = {
      emailAddress: emailAddress,
      password: password,
      // ipAddress: resIP.data.ipString,
      ipAddress: "",
    };
    try {
      setLoading(true);
      const res = await postLoginService(payload);
      // const res = await postLoginNoVerifyService(payload);
      if (res.data.message === "pending") {
        setShowVerify(true);
        setLoading(false);
      } else if (res.data.message === "Login Successful") {
        cookies.set("TOKEN", res.data.token, {
          path: "/",
        });
        cookies.set("USER_ID", res.data.userID, {
          path: "/",
        });
        cookies.set("USER_FIRSTNAME", res.data.firstName, {
          path: "/",
        });
        cookies.set("USER_LASTNAME", res.data.lastName, {
          path: "/",
        });
        cookies.set("USER_EMAIL", res.data.email, {
          path: "/",
        });
        cookies.set("USER_ROLE", res.data.role, {
          path: "/",
        });
        setTimeout(() => {
          props.getUserRoleCookie();
          setLoading(false);
          navToHomePage();
        }, 1000);
      } else {
        setLoginErrorMessage("Incorrect email or password");
      }
    } catch (e) {
      setLoading(false);
      setLoginErrorMessage("Incorrect email or password");
      console.error("login error", e);
    }
  };

  const postVerify = async () => {
    // const resIP = await getIPAddressService();
    const payload = {
      emailAddress: emailAddress,
      verificationCode: verificationCode,
      // ipAddress: resIP.data.ipString,
      ipAddress: "",
    };
    try {
      setLoading(true);
      const res = await postVerifyService(payload);
      if (res.data.message === "Login Successful") {
        cookies.set("TOKEN", res.data.token, {
          path: "/",
        });
        cookies.set("USER_ID", res.data.userID, {
          path: "/",
        });
        cookies.set("USER_FIRSTNAME", res.data.firstName, {
          path: "/",
        });
        cookies.set("USER_LASTNAME", res.data.lastName, {
          path: "/",
        });
        cookies.set("USER_EMAIL", res.data.email, {
          path: "/",
        });
        cookies.set("USER_ROLE", res.data.role, {
          path: "/",
        });
        setTimeout(() => {
          props.getUserRoleCookie();
          setLoading(false);
          navToHomePage();
        }, 1000);
      } else {
        setVerifyErrorMessage("Incorrect verification code");
      }
    } catch (e) {
      setVerifyErrorMessage("Incorrect verification code");
      setLoading(false);
      console.error("login error", e);
    }
  };

  const postLoginNoVerify = async () => {
    try {
      setLoading(true);
      // const resIP = await getIPAddressService();
      const payload = {
        emailAddress: emailAddress,
        password: password,
        // ipAddress: resIP.data.ipString,
        ipAddress: "",
      };
      const res = await postLoginNoVerifyService(payload);
      if (res.data.message === "Login Successful") {
        cookies.set("TOKEN", res.data.token, {
          path: "/",
        });
        cookies.set("USER_ID", res.data.userID, {
          path: "/",
        });
        cookies.set("USER_FIRSTNAME", res.data.firstName, {
          path: "/",
        });
        cookies.set("USER_LASTNAME", res.data.lastName, {
          path: "/",
        });
        cookies.set("USER_EMAIL", res.data.email, {
          path: "/",
        });
        cookies.set("USER_ROLE", res.data.role, {
          path: "/",
        });
        setTimeout(() => {
          setLoading(false);
          navToHomePage();
        }, 1000);
      } else {
        setLoginErrorMessage("Incorrect email or password");
      }
    } catch (e) {
      setLoginErrorMessage("Incorrect email or password");
      setLoading(false);
      console.error("login error", e);
    }
  };

  const validateLoginForm = () => {
    let validationFormStatus = true;
    if (emailAddress === "") {
      validationFormStatus = false;
      setEmailAddressFormStatus("error");
      setEmailAddressFormMessage("Enter an email address");
    }
    if (password === "") {
      validationFormStatus = false;
      setPasswordFormStatus("error");
      setPasswordFormMessage("Enter a password");
    }
    return validationFormStatus;
  };

  const validateVerifyForm = () => {
    let validationFormStatus = true;
    if (verificationCode === "" || verificationCode.length !== 6) {
      validationFormStatus = false;
      setVerificationCodeFormStatus("error");
      setVerificationCodeFormMessage("Enter a verification code");
    }
    return validationFormStatus;
  };

  const navToSignUp = () => {
    navigate("/signup");
  };

  const navToHomePage = () => {
    navigate("/");
  };

  const navToLogin = () => {
    setEmailAddress("");
    setEmailAddressFormStatus("");
    setEmailAddressFormMessage("");
    setPassword("");
    setPasswordFormStatus("");
    setPasswordFormMessage("");
    setVerificationCode("");
    setVerificationCodeFormStatus("");
    setVerificationCodeFormMessage("");
    setLoginErrorMessage("");
    setVerifyErrorMessage("");
    setShowVerify(false);
    navigate("/login");
  };

  const updateEmailAddress = (emailAddress: string) => {
    setEmailAddressFormStatus("");
    setEmailAddressFormMessage("");
    setLoginErrorMessage("");
    setVerifyErrorMessage("");
    setEmailAddress(emailAddress);
  };

  const updatePassword = (password: string) => {
    setPasswordFormStatus("");
    setPasswordFormMessage("");
    setLoginErrorMessage("");
    setVerifyErrorMessage("");
    setPassword(password);
  };

  const updateVerificationCode = (verificationCode: string) => {
    setVerificationCodeFormStatus("");
    setVerificationCodeFormMessage("");
    setVerificationCode("");
    setLoginErrorMessage("");
    setVerifyErrorMessage("");
    setVerificationCode(verificationCode);
  };

  return (
    <Layout>
      <Content className="login-content">
        <Col span={24}>
          <Row justify="center" align="middle" style={{ height: "100dvh" }}>
            <Col span={10}>
              <Card
                title={null}
                bordered={false}
                bodyStyle={{
                  padding: "10px 10px",
                  borderRadius: "10px",
                }}
                className="login-card"
              >
                <Row justify="center" align="middle" style={{ height: "80px" }}>
                  <h1 className="login-header">Metals Trading</h1>
                </Row>
                {/* <Row justify="center" style={{ marginBottom: "20px" }}>
                  <Form style={{ width: "90%" }} layout="vertical">
                    <Form.Item
                      label={<label style={{ color: "#283555", fontWeight: "bold" }}>Email Address</label>}
                      validateStatus={emailAddressFormStatus}
                      help={emailAddressFormMessage}
                    >
                      <Input
                        size="large"
                        placeholder="Email Address"
                        value={emailAddress}
                        style={{ width: "100%" }}
                        onChange={(e) => updateEmailAddress(e.target.value)}
                      />
                    </Form.Item>
                    <Form.Item
                      label={<label style={{ color: "#283555", fontWeight: "bold" }}>Password</label>}
                      validateStatus={passwordFormStatus}
                      help={passwordFormMessage}
                    >
                      <Input.Password
                        size="large"
                        placeholder="Password"
                        value={password}
                        style={{ width: "100%" }}
                        onChange={(e) => updatePassword(e.target.value)}
                        onPressEnter={() => validateLoginForm() && postLoginNoVerify()}
                      />
                    </Form.Item>
                    <div className="login-error-message">{loginErrorMessage}</div>
                  </Form>
                </Row> */}
                {/* <Row justify="center" style={{ marginBottom: "10px" }}>
                  <Button
                    type="primary"
                    size="large"
                    loading={loading}
                    onClick={() => validateLoginForm() && postLoginNoVerify()}
                    className="login-button"
                  >
                    Login
                  </Button>
                </Row> */}
                {showVerify ? (
                  <>
                    <Row justify="center" style={{ marginBottom: "20px" }}>
                      <Form style={{ width: "90%" }} layout="vertical">
                        <Form.Item
                          label={<label style={{ color: "#283555", fontWeight: "bold" }}>Verification Code</label>}
                          validateStatus={verificationCodeFormStatus}
                          help={verificationCodeFormMessage}
                        >
                          <Input
                            size="large"
                            placeholder="Verification Code"
                            value={verificationCode}
                            style={{ width: "100%" }}
                            onChange={(e) => updateVerificationCode(e.target.value)}
                            onPressEnter={() => validateVerifyForm() && postVerify()}
                          />
                        </Form.Item>
                        <div className="verify-error-message">{verifyErrorMessage}</div>
                      </Form>
                    </Row>
                    <Row justify="center" style={{ marginBottom: "10px" }}>
                      <Button
                        type="primary"
                        size="large"
                        loading={loading}
                        onClick={() => validateVerifyForm() && postVerify()}
                        className="login-button"
                      >
                        Verify
                      </Button>
                    </Row>
                    <Row justify="center">
                      <Button type="link" className="resend-code-button" onClick={() => postLogin()}>
                        Resend Verification Code
                      </Button>
                    </Row>
                    <Row justify="center">
                      <Button type="link" className="nav-to-login-button" onClick={() => navToLogin()}>
                        Back to Login
                      </Button>
                    </Row>
                  </>
                ) : (
                  <>
                    <Row justify="center" style={{ marginBottom: "20px" }}>
                      <Form style={{ width: "90%" }} layout="vertical">
                        <Form.Item
                          label={<label style={{ color: "#283555", fontWeight: "bold" }}>Email Address</label>}
                          validateStatus={emailAddressFormStatus}
                          help={emailAddressFormMessage}
                        >
                          <Input
                            size="large"
                            placeholder="Email Address"
                            value={emailAddress}
                            style={{ width: "100%" }}
                            onChange={(e) => updateEmailAddress(e.target.value)}
                          />
                        </Form.Item>
                        <Form.Item
                          label={<label style={{ color: "#283555", fontWeight: "bold" }}>Password</label>}
                          validateStatus={passwordFormStatus}
                          help={passwordFormMessage}
                        >
                          <Input.Password
                            size="large"
                            placeholder="Password"
                            value={password}
                            style={{ width: "100%" }}
                            onChange={(e) => updatePassword(e.target.value)}
                            onPressEnter={() => validateLoginForm() && postLogin()}
                          />
                        </Form.Item>
                        <div className="login-error-message">{loginErrorMessage}</div>
                      </Form>
                    </Row>
                    <Row justify="center" style={{ marginBottom: "10px" }}>
                      <Button
                        type="primary"
                        size="large"
                        loading={loading}
                        onClick={() => validateLoginForm() && postLogin()}
                        className="login-button"
                      >
                        Login
                      </Button>
                    </Row>
                  </>
                )}

                {/* <Row justify="center">
                  <Button type="link" className="sign-up-button" onClick={() => navToSignUp()}>
                    Don't have an account? Sign Up Here!
                  </Button>
                </Row> */}
              </Card>
            </Col>
          </Row>
          <Copyright />
        </Col>
      </Content>
    </Layout>
  );
};

export default LoginPage;
